import slugify from 'slugify'
import { z } from 'zod'
import { isBeta } from './deploymentConfig'

export const createSlug = (text: string) => {
	// Clean up the slug: remove parentheses but keep content, replace dots with hyphens
	const cleaned = text
		.replace(/[()]/g, '') // Remove parentheses but keep content inside
		.replace(/\./g, '-') // Replace dots with hyphens
		.trim()
	return slugify(cleaned, { lower: true, strict: true })
}

const kriteria = z
	.array(
		z.object({
			nazev_kriteria: z.array(z.string()),
			hodnoceni: z.array(z.string()).optional(),
			popis: z.array(z.string()),
		}),
	)
	.optional()

const mediaMapScheme = z.object({
	mapa_medii: z.array(
		z.object({
			web: z.object({
				detail_o_webu: z.object({
					nazev: z.array(z.string()),
					adresa_webu: z.array(z.string()),
					screenshot: z.array(z.string()),
					kategorie: z.array(z.string()),
					popis: z.array(z.string()),
					datum_posledniho_hodnoceni: z.array(z.string()),
				}),
				kriteria,
			}),
		}),
	),
})

export async function getMediaItems() {
	const categories = [
		{
			type: 'mapa_medii',
			url: isBeta
				? 'http://rating.nfnz.cz.s3.amazonaws.com/mapa_medii_json/mamamedii_beta.json'
				: 'http://rating.nfnz.cz.s3.amazonaws.com/mapa_medii_json/mapamedii.json',
		},
	] as const

	const data = await Promise.all(
		categories.map(async (category) => {
			const response = await fetch(category.url)
			const json = await response.json()

			return {
				data: mediaMapScheme.parse(json).mapa_medii.map(
					(mapScheme) =>
						({
							...mapScheme.web,
							slug: createSlug(mapScheme.web.detail_o_webu.kategorie[0]),
						} as const),
				),
			} as const
		}),
	)

	const items = data.flatMap((categoryItems) => categoryItems.data)

	return items
}
